import { render } from "./NewsSection.vue?vue&type=template&id=56dcac04"
const script = {}

import "./NewsSection.vue?vue&type=style&index=0&id=56dcac04&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__